export default __webpack_public_path__ + "static/media/IconCancel.adceaec6.svg";